export default function returnUrlParams(obj) {
  return Object.entries(obj)
    .map(kv => {
      return kv
        .map(el =>
          encodeURIComponent(Array.isArray(el) ? JSON.stringify(el) : el)
        )
        .join("=");
    })
    .join("&");
}
